// @flow
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    hotkeyModalTitle: {
        defaultMessage: 'Keyboard Shortcuts',
        description: 'Title for keyboard shortcut help modal',
        id: 'boxui.core.hotkeys.hotkeyModalTitle',
    },
    enterKey: {
        defaultMessage: 'Enter',
        description: 'Label for "Enter" key',
        id: 'boxui.core.hotkeys.enterKey',
    },
    spacebarKey: {
        defaultMessage: 'Spacebar',
        description: 'Label for "Spacebar" key',
        id: 'boxui.core.hotkeys.spacebarKey',
    },
    shiftKey: {
        defaultMessage: 'Shift',
        description: 'Label for "Shift" key',
        id: 'boxui.core.hotkeys.shiftKey',
    },
    ctrlKey: {
        defaultMessage: 'Ctrl',
        description: 'Label for "Control" key',
        id: 'boxui.core.hotkeys.ctrlKey',
    },
    altKey: {
        defaultMessage: 'Alt',
        description: 'Label for "Alt" key',
        id: 'boxui.core.hotkeys.altKey',
    },
    escKey: {
        defaultMessage: 'Esc',
        description: 'Label for "Esc" key',
        id: 'boxui.core.hotkeys.escKey',
    },
    hotkeySequence: {
        defaultMessage: '{key1} then {key2}',
        description:
            'Describes a hotkey sequence, e.g. "shift+g then shift+a". {key1} is the first key ("shift+g" in our example) and {key2} is the second ("shift+a" in our example).',
        id: 'boxui.core.hotkeys.hotkeySequence',
    },
});

export default messages;
